import { render, staticRenderFns } from "./RoundedButton.vue?vue&type=template&id=3b0301ca&scoped=true&"
import script from "./RoundedButton.vue?vue&type=script&lang=js&"
export * from "./RoundedButton.vue?vue&type=script&lang=js&"
import style0 from "./RoundedButton.vue?vue&type=style&index=0&id=3b0301ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0301ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
